import { render, staticRenderFns } from "./AppAlerts.vue?vue&type=template&id=1a37f81a&scoped=true&"
import script from "./AppAlerts.vue?vue&type=script&lang=js&"
export * from "./AppAlerts.vue?vue&type=script&lang=js&"
import style0 from "./AppAlerts.vue?vue&type=style&index=0&id=1a37f81a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a37f81a",
  null
  
)

export default component.exports